import React from 'react';
import { useState, useEffect } from 'react';

import {lit, rit} from '../Util/IconText';

import Button from 'react-bootstrap/Button';
import { Form, Row, Col, FloatingLabel, FormLabel } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';

import { logD } from '../Util/Util';
import conf from '../../config.json';

export default function Detail(props) {
    logD('launch.Config', props);
    const draft = props.release;
    const selected = props.selected;
    //const [selected, setSelected] = useState(props.launch);

    const changeValue = (e) => {
        console.log('e.target.name ' + e.target.name + ' e.target.value ' + e.target.value);
        selected[e.target.name] = e.target.value;
        document.getElementsByName(e.target.name).value = selected[e.target.name];
        //setSelected(selected);
    }

    const changeCheckValue = (e) => {
        e.target.value = e.target.checked;
        selected[e.target.name] = e.target.value;
    }

    const changeConfigValue = (e, type) => {
        console.log(type + " " + e.target.name);
        e.target.value = e.target.checked;
        selected.config[type] = e.target.checked;
    }

    const changeTextValue = (e, idx) => {
        console.log('changeTextValue ' + idx);
        selected.questiontexts[idx].questionText[e.target.name] = e.target.value;
    }

    const changeEditorValue = (key, value, idx) => {
        selected.questiontexts[idx].questionText[key] = value;
    }

    const changeTextConfigValue = (e, type) => {
        selected.config[type]= e.target.value;
    }

    const changeEnumConfigValue = (e, type) => {
        console.log('changeEnumConfigValue ');
        console.log(e);
        selected.config[type].value = e.target.value;
    }

    const handleSubmit = (e) => {
        logD('Questions.Detail.handleSubmit', e);
        console.log(e.target);
        console.log(e.target.id);
        e.preventDefault();
        if(e.target.id === 'updateL' + selected.idLaunch) {
            e.preventDefault();
            const formData = new FormData(e.target);
            const data = Object.fromEntries(formData.entries());
            data['idRelease'] = draft.idDraft;
            data['enabled'] = selected.enabled;
            data['config'] = JSON.stringify(selected.config);
            data['start'] = new Date(data['start']).getTime();
            data['end'] = new Date(data['end']).getTime();

            console.log(data);
            console.log(selected);
            fetch(conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/action/updateLnch', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + props.token
                },
                body: JSON.stringify(data),
            })
            .then(props.handleError)
            .then((data) => {
                props.handleFinish();
            });
        }
    }

    function renderConfig(config) {//TODO: mostrar o no ciertas configuraciones
        return Object.keys(config).map(function(key, idx) {
            if(config[key] != null) {
                //let item = Object.keys(config[key]).map(function(key, idx) {
                    let item;
                    //console.log("type + key");
                    //console.log(key + " " + key);
                    if(config[key] != null) {
                        if(typeof selected.config[key] === 'boolean') {
                            item = <Form.Group key={idx} as={Col} className="mb-3" controlId={key}>
                                        <Form.Check name={key} type="checkbox" label={lit(key)} onChange={(e) => changeConfigValue(e, key)} defaultChecked={selected.config[key]}/>
                                    </Form.Group>
                        } else if(typeof selected.config[key] === 'string') {
                            item = <Form.Group key={idx} as={Col} className="mb-3" controlId={key}>
                                        <FloatingLabel
                                            controlId={key}
                                            label={lit(key)}
                                            className="mb-3"
                                        >
                                            <Form.Control name={key} placeholder={lit(key)} defaultValue={selected.config[key]} onChange={(e) => changeTextConfigValue(e, key)}/>
                                        </FloatingLabel>
                                    </Form.Group>
                        } else if(typeof selected.config[key] === 'object' && selected.config[key].hasOwnProperty('values')) {
                            item = <Form.Group key={idx} as={Row} className="mb-3" controlId={key}>
                                        <Form.Label column xs="2">{lit(key)}</Form.Label>
                                        <Col xs="10">
                                            <Form.Select name={key}
                                                defaultValue={selected.config[key].value}
                                                onChange={(e) => changeEnumConfigValue(e, key)}>
                                                {
                                                    selected.config[key].values.map(function(opt) {
                                                        return <option key={opt} 
                                                                    id={opt} 
                                                                    value={opt}
                                                                    className={"option"+key}
                                                                    >{opt}</option>
                                                    })
                                                }
                                            </Form.Select>
                                        </Col>
                                    </Form.Group>
                        } else {
                            item = <Form.Group key={idx} as={Col} className="mb-3" controlId={key}>
                                        <FloatingLabel
                                            controlId={key}
                                            label={lit(key)}
                                            className="mb-3"
                                        >
                                            <Form.Control name={key} placeholder={lit(key)} defaultValue={selected.config[key]} onChange={(e) => changeTextConfigValue(e, key)}/>
                                        </FloatingLabel>
                                    </Form.Group>
                        }
                        //return item;
                    }
                //});
                return item;
            }
        })
    }

    if(selected != null) {
        return (
            <>
                <Form id={'updateL' + selected.idLaunch} onSubmit={handleSubmit} className="mb-2">
                    {console.log('selected')}
                    {console.log(selected)}
                    <Row>
                        <Col xs="2">
                            <Button className='mb-1' type="submit">{lit('apply_changes')}</Button>
                        </Col>
                        <Col xs="10">
                        </Col>
                    </Row>
                    <input name="idLaunch" type="hidden" value={selected.idLaunch} />
                    <Row>
                        <Form.Group as={Col} xs="4" className="mb-3" controlId="code">
                            <FloatingLabel
                                controlId="code"
                                label={lit('code')}
                            >
                            <Form.Control name="code" placeholder={lit('code')} defaultValue={selected.code} onChange={(e) => changeValue(e)}/>
                            </FloatingLabel>
                        </Form.Group>
                        <Form.Group as={Col} xs="8" className="mb-3" controlId="description">
                            <FloatingLabel
                                controlId="description"
                                label={lit('description')}
                            >
                            <Form.Control name="description" placeholder={lit('description')} defaultValue={selected.description} onChange={(e) => changeValue(e)}/>
                            </FloatingLabel>
                        </Form.Group>
                    </Row>
                    <Row>
                        <Form.Group as={Col} className="mb-3" controlId="start">
                            <FormLabel>{lit('start')}</FormLabel>
                            <input type="datetime-local" name="start" defaultValue={new Date(new Date(selected.start).toString().split('GMT')[0]+' UTC').toISOString().split('.')[0]} onChange={(e) => changeValue(e)}/>
                            
                        </Form.Group>
                        <Form.Group as={Col} className="mb-3" controlId="end">
                            <FormLabel>{lit('end')}</FormLabel>
                            <input type="datetime-local" name="end" defaultValue={new Date(new Date(selected.end).toString().split('GMT')[0]+' UTC').toISOString().split('.')[0]} onChange={(e) => changeValue(e)}/>
                        </Form.Group>
                    </Row>
                    <Accordion defaultActiveKey="0">
                        {selected.config != null && <Accordion.Item eventKey="1">
                            <Accordion.Header>
                                {lit('config')}
                            </Accordion.Header>
                            <Accordion.Body>
                                <Accordion defaultActiveKey="0">
                                    {renderConfig(selected.config)}
                                </Accordion>
                            </Accordion.Body>
                        </Accordion.Item>}
                    </Accordion>
                </Form>
            </>
        );
    }
};